import { IconProps } from "./types";

export default function IcoPath({
	color = "#707070",
	width = "16",
	height = "16"
}: IconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
		>
			<g clipPath="url(#clip0_636_3533)">
				<path
					d="M16 3C16 4.56875 14.1531 6.90938 13.3562 7.84375C13.2375 7.98125 13.0625 8.03438 12.9031 8H10C9.44687 8 9 8.44687 9 9C9 9.55313 9.44687 10 10 10H13C14.6562 10 16 11.3438 16 13C16 14.6562 14.6562 16 13 16H4.3625C4.63438 15.6906 4.96563 15.2938 5.3 14.85C5.49688 14.5875 5.7 14.3 5.89375 14H13C13.5531 14 14 13.5531 14 13C14 12.4469 13.5531 12 13 12H10C8.34375 12 7 10.6562 7 9C7 7.34375 8.34375 6 10 6H11.2437C10.5875 5.01562 10 3.88438 10 3C10 1.34375 11.3438 0 13 0C14.6562 0 16 1.34375 16 3ZM3.65937 15.2844C3.54062 15.4187 3.43438 15.5375 3.34375 15.6375L3.2875 15.7L3.28125 15.6938C3.09375 15.8375 2.825 15.8187 2.65625 15.6375C1.86875 14.7812 0 12.5781 0 11C0 9.34375 1.34375 8 3 8C4.65625 8 6 9.34375 6 11C6 11.9375 5.34062 13.0938 4.64062 14.0594C4.30625 14.5188 3.9625 14.9344 3.67812 15.2625L3.65937 15.2844ZM4 11C4 10.7348 3.89464 10.4804 3.70711 10.2929C3.51957 10.1054 3.26522 10 3 10C2.73478 10 2.48043 10.1054 2.29289 10.2929C2.10536 10.4804 2 10.7348 2 11C2 11.2652 2.10536 11.5196 2.29289 11.7071C2.48043 11.8946 2.73478 12 3 12C3.26522 12 3.51957 11.8946 3.70711 11.7071C3.89464 11.5196 4 11.2652 4 11ZM13 4C13.2652 4 13.5196 3.89464 13.7071 3.70711C13.8946 3.51957 14 3.26522 14 3C14 2.73478 13.8946 2.48043 13.7071 2.29289C13.5196 2.10536 13.2652 2 13 2C12.7348 2 12.4804 2.10536 12.2929 2.29289C12.1054 2.48043 12 2.73478 12 3C12 3.26522 12.1054 3.51957 12.2929 3.70711C12.4804 3.89464 12.7348 4 13 4Z"
					fill={color}
				/>
			</g>
			<defs>
				<clipPath id="clip0_636_3533">
					<path d="M0 0H16V16H0V0Z" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
